__turbopack_context__.v({
  "className": "lexend_ac8d357b-module__2NeGeq__className",
});
